const defaultPopoverOverlayConfig = {
    hasBackdrop: true,
    backdropClass: '',
    maxWidth: '20em',
};
const defaultPopoverConfig = Object.assign(Object.assign({}, defaultPopoverOverlayConfig), { 
    // popover
    disableClose: false, 
    // popover arrow
    arrowOffset: 20, arrowSize: 20, stopEventOnEsc: false });
export const applyPopoverConfigDefaults = (config, defaultConfig) => {
    return Object.assign(Object.assign(Object.assign({}, defaultPopoverConfig), defaultConfig), config);
};
